import { render } from "./NoahChat.vue?vue&type=template&id=62e7ddc2&scoped=true"
import script from "./NoahChat.vue?vue&type=script&lang=js"
export * from "./NoahChat.vue?vue&type=script&lang=js"

import "./NoahChat.vue?vue&type=style&index=0&id=62e7ddc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e7ddc2"]])

export default __exports__